import { injectIntl } from "react-intl";
import React, { memo, useEffect } from "react";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { 
    verifyMfaSms, 
    selectVerifySmsStatus, 
    selectVerifySmsErrorMessage, 
    resetMfaStatus 
} from "../../redux";
import { ReduxState } from "../../../../redux/types";
import paths from "../../../../helper/pathRoutes";
import { Formik } from 'formik';

function MfaSms() {
    const history = useHistory();
    const dispatch = useDispatch();

    const verifySmsStatus = useSelector(selectVerifySmsStatus);
    const verifySmsErrorMessage = useSelector(selectVerifySmsErrorMessage);

    useEffect(() => {
        dispatch(resetMfaStatus());
    }, [dispatch]);

    const initialValues = {
        smsCode: ''
    };

    // ★追加：必須チェック（未入力チェック）および古いAPIエラーのお掃除ロジック
    const validate = (values) => {
        const errors = {};
        if (!values.smsCode) {
            errors.smsCode = 'SMS認証コードは必ず入力してください。';
            
            // 必須チェック失敗時にAPI側の古いエラー表示（赤文字）を消去する
            dispatch(resetMfaStatus());
        } else if (values.smsCode.length !== 4 || !/^\d{4}$/.test(values.smsCode)) {
            errors.smsCode = 'SMS認証コードは4桁の数字で入力してください。';
            dispatch(resetMfaStatus());
        }
        return errors;
    };

    const onSubmit = (values, { setSubmitting }) => {
        // history.location.state から 'from' を取得
        const fromPage = history.location?.state?.from || '';

        // ★修正：Sagaへ送るペイロードに from を追加
        dispatch(verifyMfaSms({ 
            smsCode: values.smsCode, 
            setSubmitting,
            from: fromPage // 👈 これを追加
        }));
    };

    return (
        <div>
            <canvas id="confetti" style={{ display: 'none' }}></canvas>

            <div className="m-pager-title">
                <div className="m-pager-title__inner">
                    <p className="m-pager-title__inner__title">認証＞SMS認証コード入力</p>
                </div>
            </div>
            <Formik
                initialValues={initialValues}
                validate={validate} // ★追加：バリデーションを登録
                validateOnChange={false}
                validateOnBlur={false}
                onSubmit={onSubmit}
            >
                {propsFormik => (
                    <form id="form" onSubmit={propsFormik.handleSubmit}>
                        <div className="t-contents t-contents--bg-ivory">
                            <div className="o-entry" ref={el => el && el.style.setProperty('max-width', '700px', 'important')}>
                                <p
                                    className="m-animal-header__normal-title u-mb5"
                                    style={{ color: "#333" }}
                                >
                                    SMS認証コード入力
                                </p>
                                <p
                                    className="m-animal-header__normal-title u-mb15"
                                    style={{ color: "#333", fontWeight: 'normal' ,fontSize:"16px"}}>
                                    SMS認証コードを入力し、認証するボタンをクリックしてください。
                                </p>
                            </div>

                            {/* ★修正：エラー表示時も全体のサイズが崩れないよう、外枠のラッパー要素にスタイルを指定 */}
                            <div className="u-mb20" style={{ width: "200px", display: "block", margin: "0 auto" }}>
                                <input 
                                    type="text" 
                                    name="smsCode"
                                    maxLength={4}
                                    style={{ width: "200px", display: "block", margin: "0 auto" }}
                                    // ★修正：必須エラーがある時だけ、入力枠に「is-required」クラスを付与
                                    className={`a-input-text ${propsFormik.errors.smsCode ? "is-required" : ""}`}
                                    placeholder="SMS認証コード" 
                                    value={propsFormik.values.smsCode}
                                    onChange={(e) => {
                                        const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                                        propsFormik.setFieldValue('smsCode', onlyNums);
                                    }}
                                />
                                {/* ★追加：必須エラーメッセージをご指定のHTML構造・クラス名で出力 */}
                                {propsFormik.errors.smsCode && (
                                    <span className="u-fwBold u-fz11 a-color--pink">
                                        {propsFormik.errors.smsCode}
                                    </span>
                                )}
                            </div>

                            {/* APIの検証エラー用（必須チェック失敗時は、自動的に非表示になります） */}
                            {verifySmsStatus === ReduxState.ERROR && verifySmsErrorMessage && (
                                <p className="has-text-centered" style={{ color: "rgb(255, 0, 0)", marginTop: "20px" }}>
                                    {verifySmsErrorMessage}
                                </p>
                            )}
                            
                            <div 
                                className="t-footer-contents__body" 
                                style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "20px" }}
                            >
                                <button 
                                    type="button"
                                    className="a-button a-button--submit a-button--pc-w330 a-button--round u-fz16 js-validation" 
                                    style={{ width: "150px", margin: "unset" }}
                                    onClick={() => history.push(paths.mfa)}
                                >
                                    戻る
                                </button>
                                
                                <button 
                                    type="submit" 
                                    // ★修正：disabledを完全に削除し、常にボタンを押せる（活性）状態に変更
                                    className="a-button a-button--submit a-button--pc-w330 a-button--round u-fz16 js-validation" 
                                    style={{ 
                                        width: "150px", 
                                        margin: "unset",
                                        opacity: 1,           // ★常に100%不透明
                                        cursor: "pointer"     // ★常に指マーク
                                    }}
                                >
                                    {propsFormik.isSubmitting ? "認証中..." : "認証する"}
                                </button>
                            </div>
                        </div>
                    </form>
                )}
            </Formik>
        </div>
    );
}

export default memo(injectIntl(MfaSms));